import React from 'react';
import { MinorInfoCard } from '../MinorInfoCard';
import { OffenderReviewCard } from '../OffenderReviewCard';
import { PrimaryButton } from '../BasicForm';
import { relationships } from '../../utils/relationshipList';

export const SelectedMinorReview = ({offenders, minorFields, handleEditClick, minorId}) => (
	<div>
		<MinorInfoCard 
			felonyConviction={minorFields.felonyConviction}
			victimOfOffender={minorFields.victimOfOffender}
			courtSupervision={minorFields.courtSupervision}
			gangAssociation={minorFields.gangAssociation}
		/>
		<div className="minor-offender-list-header">
			<h3>Inmate(s) for Minor to Visit</h3>
			<PrimaryButton 
				className="link-style"
				label="Edit"
				handleClick={handleEditClick}
				options={{
					minorId: minorId,
					url: "/minor-visit-selection"
				}} />
			<p className="description">Below are the inmates you have selected for the minor to visit.</p>
		</div>
		<ul className="visitation-result-cards">
			{Object.keys(offenders).length > 0 ?
				Object.keys(offenders).map(offenderId => {
					const offender = offenders[offenderId];
					return (
						<OffenderReviewCard 
							key={offenderId}
			                FullName={offender.FullName}
			                Age={offender.Age}
			                Race={offender.Race}
			                Gender={offender.Gender}
			                Alias={offender.Alias}
			                OffenderId={offender.OffenderId}
			                LocationName={offender.LocationName}
			                ProjectedReleaseDate={offender.ProjectedReleaseDate}
			                RelationshipToVisitor={relationships[offender.RelationshipToMinor.value]} />
					)
				})
				:(
					<li className="result-data">
						<p>No inmates have been selected for this minor to visit.</p>
					</li>
				)
			}	
		</ul>
	</div>
);


// WEBPACK FOOTER //
// ./src/components/SelectedMinorReview/SelectedMinorReview.js